export default __webpack_public_path__ + "static/media/Traditional-coffee-filter.a60fd8fb.png";